const GATEWAY_HOST_BY_SITE_HOST: Record<string, string> = {
  "dev.website.cosx.dev": "https://api.dev.cosx.dev",
  "test.website.cosx.dev": "https://api.test.cosx.dev",
  "stag.website.cosx.dev": "https://api.stag.cosx.dev",
  "cosx.co": "https://api.xeni.legal",
  "www.cosx.co": "https://api.xeni.legal",
  localhost: "https://api.dev.cosx.dev",
  "127.0.0.1": "https://api.dev.cosx.dev",
};

const DEFAULT_GATEWAY_BASE_URL = "https://api.dev.cosx.dev";

export function resolveFundComplianceGatewayBaseUrl(hostname?: string) {
  if (!hostname && typeof window === "undefined") {
    return DEFAULT_GATEWAY_BASE_URL;
  }

  const currentHost = hostname ?? window.location.hostname;
  return GATEWAY_HOST_BY_SITE_HOST[currentHost] ?? DEFAULT_GATEWAY_BASE_URL;
}

export function resolveFundComplianceGatewayWsUrl(hostname?: string) {
  return resolveFundComplianceGatewayBaseUrl(hostname).replace(/^http/, "ws");
}
